import React from "react";
import { Route, Navigate, useLocation } from "react-router-dom";
import { useAtomValue } from "jotai";
import { isAuthenticatedAtom } from "@/stores/auth.atom";
import LoginPage from "@/pages/login";
import AuthCallback from "@/pages/auth/callback";
import OnboardingPage from "@/pages/onboarding";
import DeauthorizeCallback from "@/pages/auth/deauthorize";
import LandingPage from "@/pages/landing";
import AppStorePage from "@/pages/appstore";
import First100Page from "@/pages/first-100";
import HealthAIPage from "@/pages/health-ai";
import VisionMissionPage from "@/pages/vision-mission";

// Auth Route Wrapper (redirects if already authenticated)
export const AuthRoute = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);
  const location = useLocation();

  if (isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export const authRoutes = [
  <Route key="root" path="/" element={<LandingPage />} />,
  <Route key="appstore" path="/appstore" element={<AppStorePage />} />,
  <Route
    key="location"
    path="/location"
    element={<Navigate to="/" replace />}
  />,
  <Route key="onboarding" path="/onboarding" element={<OnboardingPage />} />,
  <Route key="first-100" path="/first-100" element={<First100Page />} />,
  <Route key="health-ai" path="/health-ai" element={<HealthAIPage />} />,
  <Route
    key="vision-mission"
    path="/vision-mission"
    element={<VisionMissionPage />}
  />,
  <Route
    key="login"
    path="/login"
    element={
      <AuthRoute>
        <LoginPage />
      </AuthRoute>
    }
  />,
  <Route
    key="auth-callback"
    path="/auth/callback"
    element={<AuthCallback />}
  />,
  <Route
    key="auth-deauthorize"
    path="/auth/deauthorize"
    element={<DeauthorizeCallback />}
  />,
];
